import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CommunicationService} from '../../../core/services/communication.service';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import {DomSanitizer} from '@angular/platform-browser';
import {FuseDeleteDialogComponent} from '../../../core/components/delete-dialog/delete-dialog.component';
import {ToastrService } from 'ngx-toastr';
import {fromEvent as observableFromEvent} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
    selector: 'news-page',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    standalone: false
})

export class NewsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  emails = [];
  _pageIndex = 0;
  _perPage = 10;
  _search = '';
  totalCount = 0;
  chosenEmail;
  mailBody: any = '';
  mailTitle: any = '';

  constructor(private communicationService: CommunicationService, private sanitizer: DomSanitizer,
              public dialog: MatDialog, public toastr: ToastrService ) {

  }

  ngOnInit() {
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          this._pageIndex = 0;
          this.getAdminCommunication();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search) {
          this._search = '';
          this._pageIndex = 0;
          this.getAdminCommunication();
        }
      });
    this.getAdminCommunication();
  }

  getAdminCommunication() {
    this.communicationService.getAdminCommunication(this._pageIndex + 1, this._perPage, this._search).subscribe((res: any) => {
      this.emails = res.list;
      this.totalCount = res.totalCount;
      setTimeout(() => {
        this.mailBody = '';
        this.mailTitle = '';
        this.chosenEmail = '';
        if (this.emails && this.emails.length) {
          this.chooseMail(this.emails[0], this.emails[0].id);
        }
      }, 1000);
    });
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    this.getAdminCommunication();
  }

  deleteEmail(email) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.communicationService.deleteEmail(email.id).subscribe((res) => {
          this.toastr.success('Email deleted' , 'Success!');
          this.getAdminCommunication();
        });
      }
    });
  }

  chooseMail(data, id) {
    this.chosenEmail = data;
    let body = data.body;
    this.mailTitle = data.title;
    this.mailBody = this.sanitizer.bypassSecurityTrustHtml(body);
    if (!data.readByAdmin) {
      this.communicationService.readEmail(id).subscribe((res: any) => {
        let index = this.emails.findIndex(el => +el.id === +id);
        this.emails[index].readByAdmin = true;
      });
    }
    let allChoosenEmails = document.getElementsByClassName('email-choosen');
    if (allChoosenEmails && allChoosenEmails.length) {
      for (let i = 0; i < allChoosenEmails.length; i++) {
        allChoosenEmails[i].classList.remove('email-choosen');
      }
    }
    let _email = document.getElementById(id);
    if (_email) {
      _email.classList.add('email-choosen');
    }
  }
}
